angular.module('bmsApp.trugreen.schedule')
	.controller('TGBulkAssignVisitsModalCtrl', function ($scope,
														  $modalInstance,
														  $q,
														  $ngBootbox,
														  TGScheduleSvc,
														  EmployeeSvc,
														  TGVisitSvc,
														  ConfigService,
														  $window,
														  params) {


		function init() {
			self.start = params.start;
			self.end = params.end;
			// load employees for date
			var employeeParams = {
				filter: {
					status: true
				}
			};

			EmployeeSvc.index(employeeParams)
				.then(function (response) {
					self.employees = response.data.employee_collection;
					self.loading = false;
				});
		}

		function cancel() {
			$modalInstance.dismiss('cancel');
		}

		function onSelectEmployeeClick(employee) {
			var param = {
				start: params.start,
				end: params.end.subtract(1, 'day'),
				employee: employee.id
			};
			TGScheduleSvc.bulkAssignVisits(param).then(function(response) {
				$modalInstance.close(response.data.visits_affected);
			});
		}

		var self = $scope.TGBulkAssignVisitsModalCtrl = {
			loading: true,
			processing: false,
			visits: [],
			methods: {
				init: init,
				cancel: cancel,
				onSelectEmployeeClick: onSelectEmployeeClick
			}
		};


	});
